import { EsRequestsOperationsDetailEnum, EsRequestsOperationsEnum } from "@edp-enums/ES/request-operations.enum";
import { EsRequestOperations, IEsRequestsOperationsFilter } from "@edp-models/ES/es-request-operatios.model";
import { EsRequestPetitions } from "@edp-models/ES/es-petitions.model";
import { ServiceES } from "@edp-models/ES/es-service.model";
import { INewRequestAndOperationES } from "@edp-pages/ES/request-and-operations-es/services-es/new-request-es.service";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { IRequestsOperationsESState } from "@edp-store/state/ES/resquest-operations-es.state";
import { createSelector } from "@ngrx/store";

const RequestsOperationsESSelector = (state: IAppEsState) => state.requestOperationsEs;
const filtersSelector = (state: IAppEsState) => state.requestOperationsEs.eSfilters;
const itemsSelector = (state: IAppEsState) => state.requestOperationsEs.eSrequestsAndOperations;
const timeslotsErrorSelector = (state: IAppEsState) => state.requestOperationsEs.eSavailableTimeSlots.lastAPIError;

export const LoadedRequestsOperationsES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSloadedRequestOperations,
    (loadedRequestOperations: boolean) => loadedRequestOperations
);

export const AssociatedContractES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSassociatedContract,
    (associatedContract: number) => associatedContract
);

export const GetRequestsOperationsES = createSelector(RequestsOperationsESSelector, (state: IRequestsOperationsESState) => state);

export const RequestsOperationsGetFiltersES = createSelector(
    GetRequestsOperationsES,
    (state: { eSfilters: IEsRequestsOperationsFilter[] }) => state.eSfilters
);

export const localSupportListES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSlocalSupportList,
    (eslocalSupportList: boolean) => eslocalSupportList
);

export const loadedServicesES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSloadedServices,
    (loadedServices: boolean) => loadedServices
);

export const FilteredRequestsAndOperationsES = createSelector(
    filtersSelector,
    itemsSelector,
    (filters: IEsRequestsOperationsFilter[], items: EsRequestPetitions[]) => {
        if (filters && items) {
            if (filters.length > 0) {
                let selectedFilter: number[] = [];
                const stateFilters = filters;

                stateFilters.forEach(filter => {
                    selectedFilter = filter.options.some(opt => opt.selected) ? [...selectedFilter, filter.id] : [...selectedFilter];
                });
                if (selectedFilter.length === 0) {
                    return items;
                }
                const _serviceFiltered = selectedFilter.some(ftrId => ftrId === 1);
                const mainfilter = _serviceFiltered ? stateFilters.find(el => el.id === 1) : stateFilters.find(el => el.id === 2);
                const selectedOptions = mainfilter.options.filter(el => el.selected);

                items = items.filter(requestOperation => {
                    if (!!_serviceFiltered) {
                        return selectedOptions.find(el => el);
                    }
                    return selectedOptions.find(el =>
                        !el.statusCode
                            ? EsRequestsOperationsDetailEnum[el.acronym.toUpperCase()] ===
                              EsRequestsOperationsDetailEnum[requestOperation.status.toUpperCase()]
                            : el.statusCode.includes(requestOperation.status.replace("pt.edp.edponline.support.help.", ""))
                    );
                });
                return items;

                /*
                IN SPAIN THERE IS NO TO VALIDATE THE SERVICES
                items = items.filter(requestOperation => {
                    if (!!_serviceFiltered) {
                        return selectedOptions.find(
                            el =>
                                (el.acronym &&
                                    requestOperation.ServiceAcronym &&
                                    el.acronym.toUpperCase() === requestOperation.ServiceAcronym.toUpperCase()) ||
                                (!requestOperation.ServiceAcronym && el.acronym.toUpperCase() === EsRequestsOperationsEnum.GENERAL)
                        );
                    } else {
                        return selectedOptions.find(el =>
                            !el.statusCode
                                ? el.name === requestOperation.status
                                : el.statusCode.includes(requestOperation.status.replace("pt.edp.edponline.support.help.", ""))
                        );
                    }
                });
                return items;
                */
            }
        } else {
            return null;
        }
    }
);

export const RequestsOperationsGetServicesES = createSelector(
    GetRequestsOperationsES,
    (state: { eSservices: ServiceES[] }) => state.eSservices
);

export const LoadedSlotsES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSloadedSlots,
    (loadedSlots: boolean) => loadedSlots
);

export const GetTimeSlotsErrorES = createSelector(timeslotsErrorSelector, (state: Error) => state);

export const GetSelectedRequestES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSselectedRequest,
    (request: EsRequestOperations) => request
);

export const GetSelectedServiceAndMotiveES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSselectedServiceAndMotive,
    (request: INewRequestAndOperationES) => request
);

export const GetNewRequestStatusES = createSelector(
    (state: IAppEsState) => state.requestOperationsEs.eSnewRequestStatus,
    (request: any) => request
);
